import AppRouter from "./components/AppRouter/AppRouter";
import styles from "./styles.module.css";

export default function Main() {
  return (
    <main className={styles.main}>
      <AppRouter />
    </main>
  );
}
